import PokerTable from '../../components/PokerTable';

const TableView = () => {
  return <PokerTable />;
};

export { TableView };